module.exports = __webpack_public_path__ + "img/288.9c1e2d41.png";